<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->

    <div id="user-data" >
      <!-- {{"Permissao adicionar "+canAddEmp}} -->
      <vx-card  class="mb-base">
        <div class="vx-row">
 <div class="vx-col w-1/4  mb-5" >
  <label for="">Data de entrada</label>
         <vs-input
         :disabled="!canAddAttendance"
         @change="getEmployees"
                class="w-full"
                icon-pack="feather"
                icon-no-border
                v-model="entry_date"
                type="date"
                v-validate="'required'"
              />
          </div>
       <div class="vx-col w-1/4  mb-5" v-if="note!='ausente' && note!='folga' && note!='licença'">
  <label for="">Hora de Entrada</label>
         <vs-input
         
         :disabled="!canAddAttendance"
                class="w-full"
                icon-pack="feather"
                icon-no-border
                v-model="entry_time"
                type="time"
                v-validate="'required'"
              />
          </div>
           <div class="vx-col w-1/4  mb-5" v-if="note!='ausente' && note!='folga' && note!='licença'">
             <label for="">Hora prevista de entrada</label> <br>
                <!-- <vs-button class="w-full" type="border" color="warning" @click="clean">Limpar</vs-button> -->
              <vs-input 
              
              :disabled="!canAddAttendance"
                class="w-full"
                icon-pack="feather"
                icon-no-border
                v-model="standard_entry_time"
                type="time"
                v-validate="'required'"
              />
          </div>
           <div class="vx-col w-1/4  mb-5" >
             <label for="">Observação</label> <br>
       <v-select 
       :disabled="!canAddAttendance"
       v-if="entry_time==''"
              v-validate="'required'"
                v-model="note"
                :options="[
                'ausente' ,
                 'folga' ,
                   'licença'
                ]"
              >
              </v-select> 
              <span v-if="entry_time!='' && entry_data!=''" class="mt-5"> Presente</span>
              <!-- <label  for="" v-if="entry_time!='' && entry_data!=''"></label> -->
          </div>
          
         
         

         
          </div>


            <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
             <label for=""></label> <br>
              <vs-button :disabled="!canAddAttendance"  class="" color="primary"  @click="saveMarcar">
                Marcar
              </vs-button>
              </div>
          </div>

      </vx-card>

   
      <vx-card title="Funcionarios">
      
        <vs-divider></vs-divider>
     
        <div class="block overflow-x-auto">
         


<vs-table multiple stripe v-model="selected" :max-items="paginate" search :data="employees">
<template  slot="header">
          
                  <select @change="getEmployees"  class="block ml-3 pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" v-validate="'excluded:1,2,3'"  v-model="paginate" name="not_in_field" data-vv-as="selected">
    <option class="vs__selected-options" value="5">5</option>
    <option class="vs__selected-options" value="10">10</option>
    <option class="vs__selected-options" value="15">20</option>
    <option class="vs__selected-options" value="50">50</option>
     <option class="vs__selected-options" value="100">100</option>
     <option class="vs__selected-options" value="500">500</option>
      <option class="vs__selected-options" value="1000">1000</option>
      <h4 class="ml-3">Total: {{total}}</h4>
  </select>
          </template>
    <template slot="thead">
      <vs-th sort-key="name">Nome</vs-th>
      <vs-th sort-key="surname">Apelido</vs-th>
      <vs-th sort-key="id">Email</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].name">
          {{ data[indextr].name }}
        </vs-td>

        <vs-td :data="data[indextr].surname">
          {{ data[indextr].surname }}
        </vs-td>

        <vs-td :data="data[indextr].email">
          {{ data[indextr].email }}
        </vs-td>


      </vs-tr>
    </template>
  </vs-table>
<div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
  <!-- <pre> {{ selected }} </pre> -->
<vs-pagination :total="totalPage" @change="getEmployees" v-model="currentPage"></vs-pagination>
        </div>
        <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto  mt-2" type="border" color="warning" @click="clean">Limpar</vs-button>
          <vs-button class="ml-4 mt-2"  @click="saveMarcar" >Marcar</vs-button>
        </div>
      </div>
    </div>

       

      </vx-card>
       
    </div>

    <vs-popup class="holamundo" title="Instruções Para o Preenchimento do modelo" :active.sync="popupUpBaixar">
    

       <div class="vx-row">
          
          
           
          
    
          
         
        </div>

<div class="flex flex-wrap items-end flex-start">
      <vs-button :disabled="!canAddAttendance" class="ml-auto mt-2" @click="updateDeficiency">Atualizar</vs-button>
      <vs-button :disabled="!canAddAttendance" class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
  </div>
</template>

<script>
import http from '../../../../http-common';
import vSelect from 'vue-select'
import { PermissionsMixin } from '../../../mixins/permissions'

export default {
  mixins:[PermissionsMixin],
    components: {
    vSelect
  },
  data() {
    return {
      total:"",
       currentPage: "",
      dataEntrada:"",
      dataSaida:"",
      estado:"",
      paginate:15,
     users:[],
     selectedUser:"",
     permission_name:[],
     role_name:[],
     err:"",
employees:[],
popupUpBaixar:false,
entry_time:"",

totalPage:"",

standard_entry_time:"",
      result:[],
employee_id:[],
entry_date:"",
note:"",
selected: [],
     
      

    }
  },

  
    computed: { //todo: descontinuei essa parte veja o watch e o metodo verifypermissions
      // canListEmp(){
      //   for(let permission in this.selectedUser.permissions){
      //     console.log("permissao", this.selectedUser.permissions[permission].name)
      //     if(this.selectedUser.permissions[permission].name == "list Employee"){
      //       return true;
      //     }
      //   }
      //   return false;
      // },
      // canAddEmp(){
      //   for(let permission in this.selectedUser.permissions){
      //     console.log("permissao", this.selectedUser.permissions[permission].name)
      //     if(this.selectedUser.permissions[permission].name == "create Employee"){
      //       return true;
      //     }
      //   }
      //   return false;
      // }
    },

    mounted() {
      this.verifyPermissions();
  },

  methods: {
    initialize(){
      this.getEmployees();
    },
   
clean(){
  this.entry_time="",
  this.entry_date=""
},

mapear(){
this.result = this.selected.map(person => (person.employees_id ));
},

 saveMarcar() {
  if(this.note=="ausente" || this.note=="folga"|| this.note=="licença"){
    this.standard_entry_time="",
    this.entry_time=""
  }
     this.result = this.selected.map(person => (person.employees_id ));
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        entry_date:this.entry_date,
        entry_time:this.entry_time,
        note:this.note,
        employee_id:this.result,
        type: 1,
        standard_entry_time:this.standard_entry_time,

      };
      this.$validator.validateAll();
    http
        .post("/attendances/attendances", data, config)
        .then((success) => {
          success;
          this.selected=[],
          this.result=[],
          this.getEmployees(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Marcações Feitas com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao Marcar ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },

 getEmployees(value) {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type:'sound'
      })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
          params: {
                        entry_date:this.entry_date,
                        type:1,
                        page:this.currentPage,
                        paginate:this.paginate
                    },
          
      };
      
      
      http
        .get("/attendances/employees", config)
        .then((result) => {
           this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.employees = result.data.Employees.data;
          this.totalPage = result.data.Employees.last_page;
          this.total =  result.data.Employees.total;

// alert("2")
        })
        .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },





  
},


}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
